import { parsePhoneNumber } from 'libphonenumber-js';
import { Ref, RefObject } from 'react';

import { ApiUserType } from '../../api/def_common_api';

//Утилитный класс
export class Util {
  private static canvas: any = null;

  //Форматирует число, добавляя пробелы через каждые 3 цифры
  //Например 45879 -> 45 879
  public static numberWithSpaces(x: any): string {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  }

  //Возвращает секретный токен для вызова api (вне админки)
  public static getTokenSecurity(): string {
    return (
      process.env.REACT_APP_SECURITY_TOKEN || '99d2ce7b16e8a43aa102f6216e19e61b'
    );
  }

  //Проверка на email
  public static isEmail(str: string): boolean {
    const EMAIL_REGEXP =
      /^(([^<>()[\].,;:\s@"]+(\.[^<>()[\].,;:\s@"]+)*)|(".+"))@(([^<>()[\].,;:\s@"]+\.)+[^<>()[\].,;:\s@"]{2,})$/iu;
    return EMAIL_REGEXP.test(String(str));
  }

  //Конвертирует телефонный номер ' 8 (924) 456-85-45 ' на '+79244568545'
  //Если телефон не валидный, то возвращает пустую строку
  public static convertPhoneNumber(str: string): string {
    let retVal = '';

    const phoneNumber = parsePhoneNumber(str, 'RU');
    if (phoneNumber) {
      if (
        phoneNumber.country === 'RU' &&
        phoneNumber.isValid() &&
        phoneNumber.number.length == 12
      ) {
        //сотовый телефон 12 символов
        retVal = phoneNumber.number;
      }
    }

    return retVal;
  }

  //Конвертирует телефонный номер +7 на 7
  public static convertPhone(str: string): string {
    let retVal = str;

    //Заменяем только один первый символ
    if (str.startsWith('+7')) retVal = str.replace('+7', '7');

    return retVal;
  }

  //Возвращает телефон из phone_or_email
  public static get_phone(phone_or_email: string): string {
    let retVal = '';

    if (!this.isEmail(phone_or_email)) {
      retVal = phone_or_email;
    }

    return retVal;
  }

  //Возвращает email из phone_or_email
  public static get_email(phone_or_email: string): string {
    let retVal = '';
    if (this.isEmail(phone_or_email)) {
      retVal = phone_or_email;
    }

    return retVal;
  }

  //Устанавливает заголовок страницы
  public static setTitle(title: string) {
    document.title = title;
  }

  //Устанавливает description страницы
  public static setDescription(description: string) {
    document
      .querySelector('meta[name="description"]')
      ?.setAttribute('content', description);
  }

  //Устанавливает для Prerender код 404, что страница типа не найдена. Prerender отдает код 404 поисковому боту
  public static setPageCode404() {
    let meta = document.createElement('meta');
    meta.setAttribute('name', 'prerender-status-code');
    meta.setAttribute('content', '404');
    document.getElementsByTagName('head')[0].appendChild(meta);
  }

  /*
  Вычисляет ширину текста в пикселях, заданного шрифта
  text - текст
  font - шрифт
  Взято из http://stackoverflow.com/questions/118241/calculate-text-width-with-javascript/21015393#21015393
  */
  public static getTextWidth(text: string, font: string) {
    //если задано, использовать кешированный холст для повышения производительности
    //иначе, создадим новый холст
    if (this.canvas == null) this.canvas = document.createElement('canvas');
    let context = this.canvas.getContext('2d');
    context.font = font;
    let metrics = context.measureText(text);
    return metrics.width;
  }

  /*
  Послать сообщение во фрэйм ifr для кроссдоменного общения
  Пример взят отсюда: https://github.com/aviboy2006/cross-domain-cookie-sharing
  Статья: https://avinashsdalvi.medium.com/cross-domain-sharing-resources-like-login-cookies-f12ca54eae44
  */
  private static postCrossDomainMessage(msg: any) {
    let ifr = document.getElementById('ifr') as HTMLIFrameElement;
    let win = ifr.contentWindow;
    if (win != null) {
      //Посылаем сообщение в админку (в communicate-api.html)
      win.postMessage(msg, 'https://admin.dazel.ru');
    }
  }

  //Установить в Local Storage другого домена ключ и значение
  public static crossDomainLocalStorageSetItem(key: string, value: string) {
    let postMsg = { key: key, value: value };
    this.postCrossDomainMessage(postMsg);
  }

  //Ковертирует рубли в копейки
  public static convertRubToKopecks(rub_str: string): number {
    let retVal = 0;

    //Меняем запятую на точку
    rub_str = rub_str.replace(',', '.');
    retVal = Number(rub_str) * 100; //в копейки

    //Если не число (буквы), то 0
    if (isNaN(retVal)) {
      retVal = 0;
    }

    return retVal;
  }

  //Ковертирует копейки в рубли
  public static convertKopecksToRub(kopecks: number): number {
    if (isNaN(kopecks)) {
      kopecks = 0;
    }

    let rub_str: number = Number(kopecks / 100);

    return rub_str;
  }

  /*
  Глубокое копирование объекта, вместе с массивами и другими объектами
  Взято из https://coderoad.ru/122102/%D0%9A%D0%B0%D0%BA%D0%BE%D0%B2-%D0%BD%D0%B0%D0%B8%D0%B1%D0%BE%D0%BB%D0%B5%D0%B5-%D1%8D%D1%84%D1%84%D0%B5%D0%BA%D1%82%D0%B8%D0%B2%D0%BD%D1%8B%D0%B9-%D1%81%D0%BF%D0%BE%D1%81%D0%BE%D0%B1-%D0%B3%D0%BB%D1%83%D0%B1%D0%BE%D0%BA%D0%BE%D0%B3%D0%BE-%D0%BA%D0%BB%D0%BE%D0%BD%D0%B8%D1%80%D0%BE%D0%B2%D0%B0%D0%BD%D0%B8%D1%8F-%D0%BE%D0%B1%D1%8A%D0%B5%D0%BA%D1%82%D0%B0-%D0%B2-JavaScript
  extends 'from' object with members from 'to'. If 'to' is null, a deep clone of 'from' is returned

  Пример:
  var obj =
  {
      date: new Date(),
      func: function(q) { return 1 + q; },
      num: 123,
      text: "asdasd",
      array: [1, "asd"],
      regex: new RegExp(/aaa/i),
      subobj:
      {
          num: 234,
          text: "asdsaD"
      }
  }

  var clone_obj = clone(obj);
  или
  var clone_obj = clone(obj, null);
  */
  public static clone(from: any, to?: any) {
    if (from == null || typeof from != 'object') return from;
    if (from.constructor != Object && from.constructor != Array) return from;
    if (
      from.constructor == Date ||
      from.constructor == RegExp ||
      from.constructor == Function ||
      from.constructor == String ||
      from.constructor == Number ||
      from.constructor == Boolean
    )
      return new from.constructor(from);

    to = to || new from.constructor();

    for (var name in from) {
      to[name] =
        typeof to[name] == 'undefined'
          ? this.clone(from[name], null)
          : to[name];
    }

    return to;
  }

  //Генерировать уникальный id
  public static getUniqueId(prefix = 'component') {
    let id = `${prefix}-${Math.random().toString(16).slice(2)}`;
    return id;
  }

  //Получить тип ApiUserType учетной записи от dadata.ru API
  public static getUserTypeFromSuggestService(
    suggest_type: string
  ): ApiUserType {
    let retVal = ApiUserType.organization;

    if (suggest_type == 'LEGAL') {
      retVal = ApiUserType.organization;
    } else if (suggest_type == 'INDIVIDUAL') {
      retVal = ApiUserType.individual_entrepreneur;
    }

    return retVal;
  }

  //Возвращает ФИО или нименование организации в зависимости от типа
  public static getUserNameOrOrgName(
    type: ApiUserType,
    org_name: string,
    firstname: string,
    middlename: string,
    surname: string
  ): string {
    if (type == ApiUserType.physical_person) {
      return `${firstname} ${middlename} ${surname}`;
    } else {
      return org_name == ''
        ? `${firstname} ${middlename} ${surname}`
        : org_name;
    }
  }

  //Удаляет все теги
  public static textByRegex(html: string) {
    return html
      .replace(/<!--[\s\S]*?--!?>/g, '')
      .replace(/<\/?[a-z][^>]*(>|$)/gi, '');
  }

  public static isActiveId<T>(
    items: Array<T & { id?: number }>,
    item_id: number
  ) {
    if (!items) return;
    const ids = items.map((item) => item.id === item_id && item_id);
    let id = ids.indexOf(item_id);
    return id !== -1;
  }
  
  public static textContent(text: string){
    text = text.replace(/<p>(&nbsp;)?<\/p>/gi, '');
    text = text.substring(0, 333);
    let lastIndex = text.lastIndexOf(' '); // позиция последнего пробела
    text = text.substring(0, lastIndex) + '...'; // обрезаем до последнего слова
    return text;
  }

  public static numberLinesText(
    textRef: RefObject<any>,
    numLines: number
  ): boolean {
    const lineHeight = parseInt(getComputedStyle(textRef.current).lineHeight);
    const blockHeight = textRef.current.clientHeight;
    const textHeight = textRef.current.getBoundingClientRect().height;
    const maxLines = Math.floor(blockHeight / lineHeight);
    const textLines = Math.ceil(textHeight / lineHeight);
    return textLines === numLines && textLines <= maxLines;
  }
}
